import { useEffect, useState } from "react";
import { InvoiceThermal } from "@/components/invoice/InvoiceThermal";
import { InvoiceA4 } from "@/components/invoice/InvoiceA4";

const btn = (active) => ({ padding: "8px 14px", borderRadius: 8, border: "1px solid #cbd5e1", fontWeight: 700, fontSize: 13, cursor: "pointer", background: active ? "#0f172a" : "#fff", color: active ? "#fff" : "#334155" });

export default function InvoiceView({ order, biz, autoPrint = false }) {
  const [mode, setMode] = useState("thermal");
  useEffect(() => { if (autoPrint) { const t = setTimeout(() => window.print(), 700); return () => clearTimeout(t); } }, [autoPrint]);

  return (
    <div style={{ fontFamily: "Arial, sans-serif", color: "#111", background: "#f1f5f9", minHeight: "100vh", padding: 16 }} data-testid="invoice-print">
      <style>{`
        @media print { .no-print{display:none!important} body{background:#fff} .sheet{box-shadow:none!important;margin:0!important} }
        .sheet{background:#fff;margin:0 auto 16px;box-shadow:0 1px 6px rgba(0,0,0,.12)}
        table{border-collapse:collapse;width:100%}
        .a4 th,.a4 td{border:1px solid #cbd5e1;padding:6px 8px;font-size:12px;text-align:left}
        .a4 th{background:#f1f5f9}
        .thermal{width:302px;padding:10px 12px;font-size:12px;line-height:1.45}
        .thermal .r{display:flex;justify-content:space-between}
        .thermal table td{font-size:11px;padding:2px 0}
        .thermal hr{border:none;border-top:1px dashed #999;margin:6px 0}
        .a4{width:760px;padding:28px 32px}
      `}</style>

      <div className="no-print" style={{ maxWidth: 760, margin: "0 auto 12px", display: "flex", gap: 8 }}>
        <button onClick={() => setMode("thermal")} style={btn(mode === "thermal")} data-testid="inv-mode-thermal">58mm Thermal</button>
        <button onClick={() => setMode("a4")} style={btn(mode === "a4")} data-testid="inv-mode-a4">A4 GST Invoice</button>
        <button onClick={() => window.print()} style={{ ...btn(false), marginLeft: "auto", background: "#0B8E36", color: "#fff", borderColor: "#0B8E36" }} data-testid="inv-print-btn">Print / Save PDF</button>
      </div>

      {mode === "thermal" ? <InvoiceThermal order={order} biz={biz} /> : <InvoiceA4 order={order} biz={biz} />}
    </div>
  );
}
